import React, { FC, useCallback } from 'react';

import CatalystsField from 'buyside/components/presentation/IdeaForm/Details/DetailsFields/catalystsField';
import InputField from 'buyside/components/presentation/Fields/inputField';
import SelectField from 'buyside/components/presentation/Fields/selectField';

import { createTimeFrameOptions } from 'buyside/util/ideaUpdateFormHelper';
import {
  determineIsSubunitCurrency,
  determineParentCurrencyCode
} from 'buyside/util/researchSubmission';
import { labelize } from 'buyside/util/arrayHelper';

import { Maybe } from 'interfaces/graphql-typings';

import styles from '../authorActionsStyles.scss';

const {
  investmentSituations,
  targetAllocation: targetAllocationConstant
} = require('buyside/util/constantsFromRails.json');

const situationOptions = labelize(investmentSituations, true);
const targetAllocationOptions = labelize(targetAllocationConstant, true);

const IdeaUpdatePositions: FC<{
  currencyCode: Maybe<string>;
  createdAt: string;
  isPairTrade: boolean;
}> = ({ currencyCode, createdAt, isPairTrade }) => {
  const timeframeOptions = createTimeFrameOptions(createdAt);

  const generateSubunitCurrencyHelperElement = useCallback(
    (price: string) => {
      if (price && currencyCode && determineIsSubunitCurrency(currencyCode))
        return (
          <label className={styles.subunitCurrencyLabel}>
            ({(Number(price) * 100).toFixed(2)} {currencyCode})
          </label>
        );

      return null;
    },
    [currencyCode]
  );

  return (
    <div className={styles.sectionContainer}>
      <div className={styles.sectionHeader}>
        <strong>Enter any position changes</strong>
        <span> (Optional)</span>
      </div>
      <div className={styles.positionContainer}>
        <div className={styles.subGroup}>
          {isPairTrade ? (
            <InputField
              type="number"
              label="Return Target"
              name="returnTarget"
              endAdornment={determineParentCurrencyCode(currencyCode || '')}
              generateHelperElement={generateSubunitCurrencyHelperElement}
              inputProps={{ min: 0, step: 0.01 }}
            />
          ) : (
            <InputField
              type="number"
              label="Price Target"
              name="priceTarget"
              inputProps={{ min: 0, step: 0.01 }}
              endAdornment={determineParentCurrencyCode(currencyCode || '')}
              generateHelperElement={generateSubunitCurrencyHelperElement}
            />
          )}
          <SelectField label="Timeframe" name="timeframe" options={timeframeOptions} />
        </div>
        <div className={styles.subGroup}>
          <SelectField label="Situation" name="situation" options={situationOptions} />
          <SelectField
            label="Target Allocation"
            name="targetAllocation"
            options={targetAllocationOptions}
          />
        </div>
        <CatalystsField name="catalysts" />
      </div>
    </div>
  );
};

export default IdeaUpdatePositions;
